export default __webpack_public_path__ + "static/media/homeScreen.da706a17.png";